'use client';

import useEmblaCarousel from 'embla-carousel-react';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { ImageItemT } from '@/forApp/types/Entity';
import ImageWithLoader from '@/shared/Image/ImageWithLoader';
import FullscreenGallery from '../FullscreenGallery';

import styles from './styles.module.css';

interface MobileImageGalleryProps {
  images: ImageItemT[];
  className?: string;
}

const MobileImageGallery: React.FC<MobileImageGalleryProps> = ({
  images,
  className = '',
}) => {
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [viewportRef, embla] = useEmblaCarousel({
    loop: true,
    skipSnaps: false,
    align: 'start',
    containScroll: 'trimSnaps',
    duration: 25,
  });

  // Sync selected index on scroll
  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
  }, [embla]);

  useEffect(() => {
    if (!embla) return;
    embla.on('select', onSelect);
    onSelect();
  }, [embla, onSelect]);

  if (!images || images.length === 0) return null;

  return (
    <>
      <div className={`${styles.gallery} ${className}`}>
        <div className={styles.embla}>
          <div className={styles.embla__viewport} ref={viewportRef}>
            <div className={styles.embla__container}>
              {images.map((img, i) => (
                <div
                  className={styles.embla__slide}
                  key={`${img.original_path}-${i}`}
                >
                  <div
                    className={styles.imageWrap}
                    onClick={() => setIsFullscreenOpen(true)}
                  >
                    <ImageWithLoader
                      src={img.original_path}
                      alt={`Фото ${i + 1}`}
                      fill
                      objectFit="cover"
                      borderRadius={0}
                      className={styles.image}
                      priority={i === 0}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/*  <IconButton
            icon={<Icons.Fullscreen />}
            onClick={() => setIsFullscreenOpen(true)}
            color="gallery"
            className={styles.fullscreenBtn}
            ariaLabel="Открыть на весь экран"
          />*/}
        </div>
      </div>

      {isFullscreenOpen && (
        <FullscreenGallery
          images={images}
          initialIndex={selectedIndex}
          onClose={() => setIsFullscreenOpen(false)}
        />
      )}
    </>
  );
};

export default MobileImageGallery;
